<template>
  <v-dialog
    style="width:100%;"
    v-model="dialog"
    class="fill-height"
    transition="dialog-transition"
    fullscreen
  >
    <div slot="activator">
      <!--
            <v-badge middle overlap color="primary lighten-2" class="productPriceBadge">
              <template v-slot:badge>
                <span class="pa-1">2 €</span>
              </template>
              -->
      <v-progress-circular
        :rotate="270"
        :size="72"
        :width="4"
        :value="100"
        color="white"
      >
        <v-progress-circular
          :rotate="270"
          :size="72"
          :width="4"
          :value="progressValue"
          color="#00A520"
        >
          <v-avatar
                v-if="this.$store.state.work.forxchange.offerRequest.contract.products[defaultContractProductIndex] != undefined"
                :class="
              'pa-0 elevation-0 productAvatar ' +
                productInputStatus(defaultContractProductIndex)
            "
          >
            <img
              :src="productImageSource(defaultContractProductIndex)"
              :class="avatarImageClass"
              alt=""
            />
          </v-avatar>
          <v-avatar
                  v-else
                  class="pa-0 elevation-0 euro-one productAvatar noProductToShow"
                  @click.stop="$emit('showHintDialog')"
          >
            <img :src="placeholderWithPriceSource" alt="" />
          </v-avatar>
        </v-progress-circular>
      </v-progress-circular>
      <!--
            </v-badge>
            -->
    </div>
    <v-card ref="prodInputDlg" color="#CCD5ED">
      <v-toolbar dark color="#002EA7">
        <v-toolbar-title>{{ productLabel }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="text-xs-center">
        <!-- zentriertes Icon -->

        <v-badge overlap>
          <template v-slot:badge>
            <button @click="showDataInputInfoDialog = true">
              <v-icon
                style="font-size:26px;border:1px solid #6682c9;border-radius:50%;background-color:#6682c9;"
                color="white"
                >info_outline
              </v-icon>
            </button>

            <v-dialog
              max-width="350px"
              class="dialog-width"
              v-model="showDataInputInfoDialog"
            >
              <v-card>
                <v-toolbar dark color="#002EA7">
                  <v-toolbar-title>Info</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon dark @click="showDataInputInfoDialog = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text>
                  <p>{{ productDescription }}</p>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>

          <v-progress-circular
            :rotate="270"
            :size="72"
            :width="4"
            :value="100"
            color="white"
          >
            <v-progress-circular
              :rotate="270"
              :size="72"
              :width="4"
              :value="progressValue"
              color="#00A520"
            >
              <v-avatar
                size="60px"
                style="overflow:hidden"
                :class="
                  'pa-0 elevation-0 productAvatar ' +
                    productInputStatus(defaultContractProductIndex)
                "
              >
                <img
                  :src="productImageSource(defaultContractProductIndex)"
                  :class="avatarImageClass"
                  alt=""
                />
              </v-avatar>
            </v-progress-circular>
          </v-progress-circular>
        </v-badge>

        <!-- @@@@@@@@ INPUT-BEREICH BEGINN @@@@@@@@ -->

        <v-form ref="form" v-model="form" class="pa-0 pt-2" @submit.stop="" @keydown.enter.native.prevent>
          <!-- HERSTELLER -->
          <v-text-field
            v-model="producer"
            box
            color="deep-purple"
            label="Hersteller, Modell, ...*"
            hint="Bitte Hersteller und eine Modellbezeichnung eingeben."
            persistent-hint
            @keydown.enter.native.prevent
          ></v-text-field>

          <!-- ****** IMEI-FOTO ****** -->
          <!-- ====== Mobile Variante ====== -->
          <div v-if="isMobileDevice && showImei">
            <make-photo-button-mobile
              :buttonlabel="contextualImeiLabel + ' fotografieren'"
              :contractProductIndex="deliverableContractProductIndex"
              intended-image-type="IMEI"
              icon="photo_camera"
            ></make-photo-button-mobile>
          </div>
          <!-- ====== Desktop Variante ====== -->
          <div v-if="!isMobileDevice && showImei">
            <v-textarea
              v-if="cameraAvailable==true"
              v-model="imei"
              auto-grow
              box
              color="deep-purple"
              :label="'Wie lautet die ' + contextualImeiLabel + ' des Gegenstands?'"
              :hint="'Bitte ' + contextualImeiLabel + ' eintippen oder fotografieren. Die IMEI ist eine 15-stellige Nummer, die das Telefon eindeutig identifiziert. Zu finden ist sie meistens unter „Einstellungen – Über das Telefon“ oder mit der Suchfunktion in den Einstellungen. Bei Dual-SIM-Geräten reicht die erste IMEI.'"
              persistent-hint
              rows="1"
              append-icon="photo_camera"
              @click:append="makeImeiPhoto"
            ></v-textarea>
            <v-textarea
                    v-if="cameraAvailable==false"
                    v-model="imei"
                    auto-grow
                    box
                    color="deep-purple"
                    :label="'Wie lautet die ' + contextualImeiLabel + ' des Gegenstands?'"
                    :hint="'Bitte ' + contextualImeiLabel + ' eintippen oder fotografieren. Die IMEI ist eine 15-stellige Nummer, die das Telefon eindeutig identifiziert. Zu finden ist sie meistens unter „Einstellungen – Über das Telefon“ oder mit der Suchfunktion in den Einstellungen. Bei Dual-SIM-Geräten reicht die erste IMEI.'"
                    persistent-hint
                    rows="1"
            ></v-textarea>
          </div>
          <v-flex xs12 v-if="imeiCameraVisible">
            <template>
              <div>
                <Camera ref="imeiCamera"></Camera>
                <v-btn fab small color="primary" @click="makeImeiPhoto">
                  <v-icon>photo_camera</v-icon>
                </v-btn>
              </div>
              <img
                      alt="IMEI-Foto"
                      :src="imeiPhotoSrc"
                      v-if="imeiPhotoSrc.length > 0"
              />
            </template>
          </v-flex>
          <!-- ****** ENDE IMEI-FOTO ****** -->

          <!-- ****** PRODUKT-FOTOS ****** -->
          <!-- ====== Mobile Variante ====== -->
          <v-flex xs12 v-if="isMobileDevice">
            <div>
              <make-photo-button-mobile
                buttonlabel="Gegenstand fotografieren"
                :contractProductIndex="deliverableContractProductIndex"
                intended-image-type="Produkt"
                icon="photo_camera"
              ></make-photo-button-mobile>
            </div>
          </v-flex>
          <!-- ====== Desktop-Variante ====== -->
          <div v-if="(!isMobileDevice) && (cameraAvailable!=false)">
            <v-flex xs12>
              <v-btn
                block
                v-show="!productCameraVisible"
                color="primary"
                @click="makeProductPhoto"
              >
                <v-flex xs10>
                  Gegenstand fotografieren
                </v-flex>
                <v-flex xs2>
                  <v-icon right>photo_camera</v-icon>
                </v-flex>
              </v-btn>
            </v-flex>
            <!-- Kamera -->
            <v-flex xs12 v-if="productCameraVisible">
              <template>
                <div>
                  <Camera ref="prodCamera"></Camera>
                  <v-btn fab small color="primary" @click="makeProductPhoto">
                    <v-icon>photo_camera</v-icon>
                  </v-btn>
                </div>
                <img
                  alt="Produktfoto"
                  :src="productPhotoSrc"
                  v-if="productPhotoSrc.length > 0"
                />
              </template>
            </v-flex>
          </div>
          <div v-if="(!isMobileDevice)">
            <v-flex xs12>
              <v-btn block
                     color="primary"
                     @click="deliverClickToFileUpload"
              >
                <v-flex xs10>
                  Datei hinzufügen
                </v-flex>
                <v-flex xs2>
                  <v-icon right>folder_open</v-icon>
                </v-flex>

              </v-btn
              >
            </v-flex>
            <v-flex xs12>
              <input id="productFileUpload"
                     ref="productFileUpload"
                     class="inputfile"
                     type="file"
                     accept="image/*,.pdf"
                     name="productFileUpload"
                     @change="handleAppendedFiles()"
              >
            </v-flex>
          </div>
          <!-- ****** ENDE PRODUKT-FOTOS ****** -->
        </v-form>


        <!-- Galerie der vorhandenen Fotos -->
        <v-flex
          xs12
          class="mt-2 mb-3"
          v-show="photoAvailable(defaultContractProductIndex)||pdfAvailable(defaultContractProductIndex)"
        >
          <v-card>
            <v-container
              grid-list-sm
              fluid
              style="background-color: rgb(192, 200, 223);"
            >
              <p class="subheading text-xs-left">{{ productLabel }}-Fotos</p>
              <p class="text-smaller">
                Bitte aussagekräftige Fotos. Der Gegenstand muss von jeder Seite
                gut erkennbar sein.
              </p>
              <v-layout row wrap>
                <v-flex
                  v-for="photo in photoArray(defaultContractProductIndex)"
                  :key="photo.fileName"
                  xs4
                  d-flex
                >
                    <v-menu
                            v-model="showImageMenu"
                            content-class="centered-button"
                            offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-card flat tile class="d-flex">
                          <v-img
                            :src="photo.data"
                            :lazy-src="photo.data"
                            aspect-ratio="1"
                            v-on="on"
                          >
                          </v-img>
                        </v-card>
                      </template>
                        <v-btn small fab dark
                               color="cta"
                               @click="removeImage(photo.fileName)"
                        >
                          <v-icon>delete_forever</v-icon>
                        </v-btn>
                    </v-menu>
                </v-flex>
                <v-flex
                        v-if="pdfAvailable(defaultContractProductIndex)"
                        v-for="pdf in pdfArray(defaultContractProductIndex)"
                        :key="pdf.name"
                        xs4
                        d-flex
                >
                    <v-menu
                            v-model="showImageMenu"
                            content-class="centered-button"
                            offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-card flat tile class="d-flex">
                          <v-icon v-on="on">
                            picture_as_pdf
                          </v-icon>
                        </v-card>
                      </template>
                      <v-btn small fab dark
                             color="cta"
                             @click="removePdf(pdf.fileName)"
                      >
                        <v-icon>delete_forever</v-icon>
                      </v-btn>
                    </v-menu>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <v-divider></v-divider>

        <v-flex xs12 class="mt-2 mb-1">
          <v-btn right xs6 color="primary" @click="deleteProduct">
            <v-flex xs2>
              <v-icon left>delete_forever</v-icon>
            </v-flex>
            <v-flex xs10>
              Entfernen
            </v-flex>
          </v-btn>
          <v-btn left xs6 color="primary" @click="acceptProduct">
            <v-flex xs2>
              <v-icon left>check</v-icon>
            </v-flex>
            <v-flex xs10>
              OK
            </v-flex>
          </v-btn>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Camera from "vue-html5-camera";
import MakePhotoButtonMobile from "./MakePhotoButtonMobile";
import PhotoGallery from "./PhotoGallery";
import {postGaMessage} from "@/stores/modules/ga";

export default {
  name: "ProductDataInput",
  data() {
    return {
      currentImageType: "Produkt",
      srcTest: "",
      dialogDefault: false,
      showDataInputInfoDialog: false,
      productCameraVisible: false,
      productPhotoSrc: "",
      billCameraVisible: false,
      billPhotoSrc: "",
      imeiCameraVisible: false,
      imeiPhotoSrc: "",
      form: false,
      showImageMenu: false,
      reader: new FileReader(),
      cameraAvailable: false
    };
  },
  props: {
    defaultContractProductIndex: {
      default: 0
    }
  },
  mounted(){
    this.checkIfCameraAvailable();
  },
  watch: {
    dialog: function(){
      let self = this;
      if(parent){
        if(this.dialog) {
          let h = this.$refs.prodInputDlg.offsetHeight;
          parent.postMessage({
            id: 'height',
            content: 1500}, "*");
        }
        else{
          parent.postMessage({
            id: 'height',
            content: 700}, "*");
          // this.$store.dispatch('work/postMessageNewHeight');
          this.$store.dispatch('work/postMessageNewSelection');
        }
      }
    },
    selectedProductsLength: function(){
      // console.log("Anzahl der ausgewählten Produkte hat sich verändert.");
      this.$store.dispatch('work/postMessageNewHeight');
      this.$store.dispatch('work/postMessageNewSelection');
    },
    progressValue(){
      // console.log("progressValue verändert auf: " + this.progressValue);
      if(this.progressValue===100){
        postGaMessage('descriptionInput','Beschreibung '+ this.productLabel +' vollständig')
      }
    }
  },
  computed: {
    contextualImeiLabel(){
      if(this.$store.state.work.forxchange.offerRequest.contract.products[
              this.defaultContractProductIndex
              ].index == 2){
        return "IMEI/Seriennummer";
      }
      return "IMEI";
    },
    placeholderWithPriceSource(){
      if(this.defaultContractProductIndex == 3) {
        return "images/icons/svg/weiss/leer_0Euro.svg";
      }
      if(this.$store.state.work.supposedlyYoungerThan32) {
        return "images/icons/svg/weiss/leer_2Euro.svg";
      }
      return "images/icons/svg/weiss/leer_4Euro.svg";
    },
    progressValue() {
      // console.log("progressValue für defaultContractProductIndex==" + this.defaultContractProductIndex + " ist " + this.dataInputProgressByIndex(this.defaultContractProductIndex));
      return this.dataInputProgressByIndex(this.defaultContractProductIndex); // <<== HIER EINEN GETTER EINSETZEN????
    },
    dialog: {
      get() {
        return ((this.$store.state.work.dialogProductDataInputState.show == true) &&
                (this.$store.state.work.dialogProductDataInputState.selectedProductIndex == this.defaultContractProductIndex)
        );
      },
      set(value) {
        let setObj = {
          selectedProductIndex: this.defaultContractProductIndex,
          show: value
        };
        this.$store.dispatch("work/setDialogProductDataInputState", setObj);
      }
    },
    isMobileDevice() {
      return (
        this.$store.state.os === "Android" || this.$store.state.os === "iOS"
      );
    },
    showImei() {
      if( this.$store.state.work.forxchange.offerRequest.contract.products[this.defaultContractProductIndex] == undefined){ return false; }
      return (
        this.$store.state.work.forxchange.offerRequest.contract.products[
          this.defaultContractProductIndex
        ].index <= 2
      );
    },
    avatarImageSrc() {
      if (this.photoAvailable(this.defaultContractProductIndex)) {
        return this.firstImageSrc;
      }
      return this.productImageSource(this.defaultContractProductIndex);
    },
    avatarImageClass(){
      if(this.isMobileDevice){
        return "mobileAvatar";
      }
      return "";
    },
    firstImageSrc() {
      if (
        this.$store.state.work.forxchange.offerRequest.contract.products !==
          undefined &&
        this.$store.state.work.forxchange.offerRequest.contract.products[
                this.defaultContractProductIndex
                ].pictures !== undefined &&
        this.$store.state.work.forxchange.offerRequest.contract.products[
          this.defaultContractProductIndex
        ].pictures[0].data !== undefined
      ) {
        // return (this.$refs.refTest.files[0].name);
        return this.$store.state.work.forxchange.offerRequest.contract.products[
          this.defaultContractProductIndex
        ].pictures[0].data;
      }
      return "nix";
    },
    productLabel() {
      if (
        this.defaultContractProductIndex >= 0 &&
        this.selectedProductsLength > this.defaultContractProductIndex &&
        this.selectedProducts[this.defaultContractProductIndex] != undefined
      ) {
        return this.selectedProducts[this.defaultContractProductIndex].label;
      }
      return "unbekannt";
    },
    productDescription() {
      if (
        this.defaultContractProductIndex >= 0 &&
        this.selectedProductsLength > this.defaultContractProductIndex &&
              this.selectedProducts[this.defaultContractProductIndex] != undefined
      ) {
        return this.selectedProducts[this.defaultContractProductIndex]
          .assortmentDescription;
      }
      return "unbekannt";
    },
    deliverableContractProductIndex() {
      return this.defaultContractProductIndex;
    },
    producer: {
      get() {
        if(this.$store.state.work.forxchange.offerRequest.contract.products[this.defaultContractProductIndex] == undefined) {
          return "";
        }
        return this.$store.state.work.forxchange.offerRequest.contract.products[
          this.defaultContractProductIndex
        ].producer;
      },
      set(value) {
        this.$store.dispatch("work/setProductProducer", {
          index: this.defaultContractProductIndex,
          text: value
        });
      }
    },
    description: {
      get() {
        return this.$store.state.work.forxchange.offerRequest.contract.products[
          this.defaultContractProductIndex
        ].description;
      },
      set(value) {
        this.$store.dispatch("work/setProductDescription", {
          index: this.defaultContractProductIndex,
          text: value
        });
      }
    },
    imei: {
      get() {
        return this.$store.state.work.forxchange.offerRequest.contract.products[
          this.defaultContractProductIndex
        ].imei;
      },
      set(value) {
        this.$store.dispatch("work/setProductImei", {
          index: this.defaultContractProductIndex,
          text: value
        });
      }
    },
    ...mapGetters("work", {
      selectedProducts: "getSelectedProducts",
      selectedProductsLength: "getSelectedProductsLength",
      dataInputProgressByIndex: "getDataInputProgressByIndex",
      productInputStatus: "getProductInputStatus",
      productImageSource: "getProductImageSource",
      photoArray: "getPhotoArray",
      photoAvailable: "getPhotoAvailable",
      pdfAvailable: "getPdfAvailable",
      pdfArray: "getPdfArray"
    })
  },
  methods: {
    checkIfCameraAvailable() {
      let self = this;
      if(this.$store.state.work.camera.tested) {
        return this.$store.state.work.camera.available;
      }
      navigator.mediaDevices.getUserMedia({video: true })
              .then(function() {
                self.cameraAvailable = true;
                self.$store.dispatch('work/postMessageAppendedHint','<strong>Achtung</strong>: Den <strong>Zugriff auf Ihre Kamera</strong> benötigen wir, damit Sie die Fotos Ihrer Gegenstände direkt erstellen können!');
                self.$store.commit('work/SET_CAMERA_AVAILABLE',self.cameraAvailable);
              })
              .catch(function() {
                self.cameraAvailable = false;
                self.$store.dispatch('work/postMessageAppendedHint','<strong>Achtung</strong>: 4gewinnt hat keinen <strong>Zugriff auf Ihre Kamera</strong>. Sie können daher nur bereits vorhandene Fotos Ihrer Gegenstände hochladen!');
                self.$store.commit('work/SET_CAMERA_AVAILABLE',self.cameraAvailable);
              });
    },
    acceptProduct(){
      this.dialog = false;
      postGaMessage('elementClicked', this.productLabel + ' bearbeitet');
    },
    deleteProduct() {
      // console.log("deleteProduct wird mit dem Index " + this.defaultContractProductIndex + " aufgerufen.");
      postGaMessage('elementClicked', this.productLabel + ' entfernt');
      this.$store.dispatch(
        "work/deleteProduct",
        this.defaultContractProductIndex
      );
      this.dialog = false;
      // console.log("this.dialog ist jetzt " + this.dialog);
    },
    /**
     * Datei-Upload
     */
    deliverClickToFileUpload(){
      this.$refs.productFileUpload.click();
    },
    handleAppendedFiles(){
      if (this.$refs.productFileUpload.files) {
        var file = this.$refs.productFileUpload.files[0];
        let fileTypes = ['jpg', 'jpeg', 'png', 'bmp'];
        let self = this;
        if(file){
          self.reader.readAsDataURL(file);
          var extension = file.name.split('.').pop().toLowerCase();
        }
        self.reader.onload = function(e) {
          if(fileTypes.indexOf(extension) > -1){
            self.$store.dispatch('work/storeProductPhoto',{ contractProductIndex: self.defaultContractProductIndex, imageData: e.target.result, imageType: extension, fileName: file.name});
          }
          if(extension === 'pdf'){
            self.$store.dispatch('work/storeProductPdf',{ contractProductIndex: self.defaultContractProductIndex, fileData: e.target.result, fileType: 'pdf', fileName: file.name});
          }
        };
      }
    },
    /**
     * Mache ein Produkt-Foto => Desktop-Variante!
     */
    makeProductPhoto() {
      if (!this.productCameraVisible) {
        this.productCameraVisible = true;
        return;
      }
      this.currentImageType = "Produkt";
      let tmp = this.$refs.prodCamera.click();
      this.storePhoto(tmp);
      this.productCameraVisible = false;
    },
    makeImeiPhoto() {
      if (!this.imeiCameraVisible) {
        this.imeiCameraVisible = true;
        return;
      }
      this.currentImageType = "IMEI";
      let tmp = this.$refs.imeiCamera.click();
      this.storePhoto(tmp);
      this.imeiCameraVisible = false;
    },
    storePhoto(tmp) {
      if(this.currentImageType == "Produkt") {
        this.$store.dispatch("work/storeProductPhoto", {
          contractProductIndex: this.defaultContractProductIndex,
          imageData: tmp
        });
      }
      if(this.currentImageType == "IMEI") {
        this.$store.dispatch("work/storeImeiPhoto", {
          contractProductIndex: this.defaultContractProductIndex,
          imageData: tmp
        });
      }
    },
    removeImage(fileName){
      this.$store.dispatch("work/removeImage",{
        contractProductIndex: this.defaultContractProductIndex,
        fileName: fileName
      });
    },
    removePdf(fileName){
      this.$store.dispatch("work/removePdf",{
        contractProductIndex: this.defaultContractProductIndex,
        fileName: fileName
      });
    },
    /*
    makeImeiPhoto() {
      if (!this.imeiCameraVisible) {
        this.imeiCameraVisible = true;
        return;
      }
      this.imeiPhotoSrc = this.$refs.imeiCamera.click();
      this.imeiCameraVisible = false;
    }, */
    showInfoDialog() {
      alert("So sieht das hier aus.");
    }
  },
  components: { PhotoGallery, MakePhotoButtonMobile, Camera }
};
</script>

<style scoped>
  .inputfile {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
div.v-avatar.noProductToShow img:hover {
  background-color: transparent;
}

div.v-avatar:not(.noProductToShow) img:hover {
  background-color: #002ea7;
}

div.v-avatar {
  background-color: #6682ca;
  /* border: 3px solid #da291c; */
}

div.v-avatar.productAvatar {
  background-color: #6682ca;
  /* border: 3px solid #da291c; */
  overflow: hidden;
  width: 64px !important;
  height: 64px !important;
}

div.v-avatar.productAvatar img {
  width: auto;
  height: inherit;
}
div.v-avatar.productAvatar img.mobileAvatar {
  width: 100% !important;
}

div.v-avatar button {
  display: none;
}

div.v-avatar.withProductAllData img {
  display: none;
}

div.v-avatar.withProductAllData button {
  display: block;
}

div.v-avatar.noProductToShow {
  background-color: #ccd5ed;
  /* border: 3px solid #da291c; */
}

div.v-avatar.noProductToShow-info {
  text-align: center;
  color: #002ea7;
  background-color: #ccd5ed;
  /* border: 3px solid #da291c; */
}

div.v-avatar.noProductToShow-info p.info::after {
  content: "Gegenstand oben auswählen";
}

div.v-avatar.withProductNoData {
  background-color: #6682ca;
  border: 0px solid white; /* #da291c; */
}

div.v-avatar.withProductNoData-info {
  background-color: #6682ca;
  border: 3px solid #da291c;
  color: white;
}

div.v-avatar.withProductNoData-info p.info::after {
  content: "Angaben zum Gegenstand machen";
}

div.v-avatar.withProductSomeData {
  background-color: #6682ca;
  border: 3px dashed #00a520;
}

div.v-avatar.withProductSomeData-info {
  text-align: center;
  background-color: #6682ca;
  border: 3px dashed #00a520;
}

div.v-avatar.withProductSomeData-info p.info::after {
  content: "Angaben vervollständigen";
}

div.v-avatar.withProductAllData {
  background-color: #6682ca;
  border: 3px solid #00a520;
}

div.v-avatar.withProductAllData-info {
  background-color: #6682ca;
  border: 3px solid #00a520;
}

div.v-avatar.withProductAllData-info p.info::after {
  content: "Perfekt!";
  text-transform: uppercase;
}
div.v-menu {
  max-width: 0px !important;
}
div.v-menu__content {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.centered-button {
  position: absolute;
  text-align: center;
  width: 100px;
  margin-top: -70px;
}
.pdf-icon {
  min-width: 90px !important;
  min-height: 90px !important;
}
</style>
